"use strict";

var _toConsumableArray = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/slicedToArray");

var _createClass = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var optim_1 = require("../optim");

var sat_1 = require("sat");

var three_1 = require("three");
/**
 * A `Shape` represents a convex boundary of a node. It has preferred dimensions, but these may be
 * expanded in order to contain children nodes. Optionally, it can have padding (inside) or margin
 * (outside) of the boundary.
 */


var Shape = function Shape(center, preserve) {
  _classCallCheck(this, Shape);

  this.center = center;
  this.preserve = preserve;
};

exports.Shape = Shape;

function fromShapeSchema(schema, center) {
  var type = schema.type,
      preserve = schema.preserve;

  switch (type) {
    case 'rectangle':
      {
        var width = schema.width,
            height = schema.height;
        return new Rectangle(center, width, height, preserve);
      }

    case 'circle':
      {
        var radius = schema.radius;
        return new Circle(center, radius, preserve);
      }

    default:
      {
        throw Error("Unrecognized ShapeSchema type: ".concat(type));
      }
  }
}

exports.fromShapeSchema = fromShapeSchema;

var Rectangle =
/*#__PURE__*/
function (_Shape) {
  _inherits(Rectangle, _Shape);

  function Rectangle(center, width, height, preserve) {
    var _this;

    _classCallCheck(this, Rectangle);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Rectangle).call(this, center, preserve));
    _this.control = new optim_1.Vector(width / 2, height / 2);
    return _this;
  }

  _createClass(Rectangle, [{
    key: "bounds",
    value: function bounds() {
      return {
        x: this.center.x - this.control.x,
        X: this.center.x + this.control.x,
        y: this.center.y - this.control.y,
        Y: this.center.y + this.control.y,
        width: this.control.x * 2,
        height: this.control.y * 2
      };
    }
  }, {
    key: "boundary",
    value: function boundary(direction) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._edges(offset)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref3 = _step.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var start = _ref2[0];
          var end = _ref2[1];
          var pt = intersectSegment(start, end, direction);
          if (pt !== undefined) return pt.add(this.center);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      throw Error("No boundary point found: direction ".concat(JSON.stringify(direction), ", edges ").concat(JSON.stringify(this._edges())));
    }
  }, {
    key: "support",
    value: function support(direction) {
      var max = Number.NEGATIVE_INFINITY;
      var support;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this._vertices()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var vertex = _step2.value;
          var dot = vertex.dot(direction);

          if (dot > max) {
            support = vertex;
            max = dot;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (!support) throw Error("No support point found: direction ".concat(direction));
      return support.add(this.center);
    }
  }, {
    key: "contains",
    value: function contains(point) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return point.x <= this.center.x + this.control.x + offset && point.x >= this.center.x - this.control.x - offset && point.y <= this.center.y + this.control.y + offset && point.y >= this.center.y - this.control.y - offset;
    }
  }, {
    key: "constrainShapesWithin",
    value: function constrainShapesWithin(subshapes) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref4$masses = _ref4.masses,
          masses = _ref4$masses === void 0 ? {
        shape: 1,
        subshapes: 1
      } : _ref4$masses;

      var box = new three_1.Box2();
      subshapes.forEach(function (subshape) {
        var _subshape$bounds = subshape.bounds(),
            x = _subshape$bounds.x,
            y = _subshape$bounds.y,
            X = _subshape$bounds.X,
            Y = _subshape$bounds.Y;

        box.union(new three_1.Box2(new optim_1.Vector(x, y), new optim_1.Vector(X, Y)));
      });
      box.expandByScalar(offset);
      var size = new optim_1.Vector();
      box.getSize(size);
      var centerGrad = new optim_1.Vector().subVectors(box.getCenter(new optim_1.Vector()), this.center).multiplyScalar(masses.subshapes / (masses.shape + masses.subshapes));
      var controlGrad = new optim_1.Vector().subVectors(size.multiplyScalar(0.5), this.control);
      var subshapeGrad = new optim_1.Vector().subVectors(box.getCenter(new optim_1.Vector()), this.center).multiplyScalar(-masses.shape / (masses.shape + masses.subshapes));
      return [new optim_1.Gradient(this.center, centerGrad), new optim_1.Gradient(this.control, controlGrad)].concat(_toConsumableArray(subshapes.map(function (s) {
        return new optim_1.Gradient(s.center, subshapeGrad.clone());
      })));
    }
  }, {
    key: "constrainPointWithin",
    value: function constrainPointWithin(point) {
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref5$masses = _ref5.masses,
          masses = _ref5$masses === void 0 ? {
        shape: 1,
        point: 1
      } : _ref5$masses,
          _ref5$expansion = _ref5.expansion,
          expansion = _ref5$expansion === void 0 ? 0 : _ref5$expansion,
          _ref5$offset = _ref5.offset,
          offset = _ref5$offset === void 0 ? 0 : _ref5$offset;

      if (this.contains(point, offset)) return [];
      return this.constrainPointOnBoundary(point, {
        masses: masses,
        expansion: expansion,
        offset: offset
      });
    }
  }, {
    key: "constrainPointOnBoundary",
    value: function constrainPointOnBoundary(point) {
      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref6$masses = _ref6.masses,
          masses = _ref6$masses === void 0 ? {
        shape: 1,
        point: 1
      } : _ref6$masses,
          _ref6$expansion = _ref6.expansion,
          expansion = _ref6$expansion === void 0 ? 0 : _ref6$expansion,
          _ref6$offset = _ref6.offset,
          offset = _ref6$offset === void 0 ? 0 : _ref6$offset;

      var centerToPoint = new optim_1.Vector().subVectors(point, this.center);
      var boundary = this.boundary(centerToPoint, offset).sub(this.center);
      var boundaryToPointOffset = centerToPoint.length() - boundary.length();
      var pointDelta = -boundaryToPointOffset * (masses.shape / (masses.shape + masses.point));
      var shapeDelta = boundaryToPointOffset * (masses.point / (masses.shape + masses.point));
      var centerDelta = shapeDelta * (1 - expansion);
      var boundaryDelta = shapeDelta * expansion;
      centerToPoint.normalize();
      var pointGrad = new optim_1.Gradient(point, centerToPoint.clone().multiplyScalar(pointDelta));
      var centerGrad = new optim_1.Gradient(this.center, centerToPoint.clone().multiplyScalar(centerDelta)); // TODO: Preserve ratio, size, none

      var controlGrad = new optim_1.Gradient(this.control, this.control.clone().multiplyScalar(boundaryDelta / boundary.length()));
      return [pointGrad, centerGrad, controlGrad];
    }
  }, {
    key: "toCollidable",
    value: function toCollidable() {
      // Vertices must be specified counter-clockwise,
      return new sat_1.Polygon(new sat_1.Vector(this.center.x, this.center.y), this._vertices().map(function (vec) {
        return new sat_1.Vector(vec.x, vec.y);
      }));
    }
  }, {
    key: "toSchema",
    value: function toSchema() {
      var preserve = this.preserve;

      var _this$bounds = this.bounds(),
          width = _this$bounds.width,
          height = _this$bounds.height;

      return {
        type: 'rectangle',
        preserve: preserve,
        width: width,
        height: height
      };
    }
  }, {
    key: "_edges",
    value: function _edges() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var _this$control = this.control,
          halfwidth = _this$control.x,
          halfheight = _this$control.y;
      var x = -halfwidth - offset,
          X = halfwidth + offset;
      var y = -halfheight - offset,
          Y = halfheight + offset;
      return [[new optim_1.Vector(x, y), new optim_1.Vector(X, y)], [new optim_1.Vector(x, Y), new optim_1.Vector(X, Y)], [new optim_1.Vector(x, y), new optim_1.Vector(x, Y)], [new optim_1.Vector(X, y), new optim_1.Vector(X, Y)]];
    }
  }, {
    key: "_vertices",
    value: function _vertices() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var _this$control2 = this.control,
          halfwidth = _this$control2.x,
          halfheight = _this$control2.y;
      var x = -halfwidth - offset,
          X = halfwidth + offset;
      var y = -halfheight - offset,
          Y = halfheight + offset;
      return [new optim_1.Vector(x, y), new optim_1.Vector(X, y), new optim_1.Vector(X, Y), new optim_1.Vector(x, Y)];
    }
  }]);

  return Rectangle;
}(Shape);

exports.Rectangle = Rectangle;

var Circle =
/*#__PURE__*/
function (_Shape2) {
  _inherits(Circle, _Shape2);

  function Circle(center, radius, preserve) {
    var _this2;

    _classCallCheck(this, Circle);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Circle).call(this, center, preserve));
    _this2.radius = new optim_1.Vector(radius, 0);
    return _this2;
  }

  _createClass(Circle, [{
    key: "bounds",
    value: function bounds() {
      return {
        x: this.center.x - this.radius.x,
        X: this.center.x + this.radius.x,
        y: this.center.y - this.radius.x,
        Y: this.center.y + this.radius.x,
        width: this.radius.x * 2,
        height: this.radius.x * 2
      };
    }
  }, {
    key: "boundary",
    value: function boundary(direction) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return direction.clone().setLength(this.radius.x).add(this.center);
    }
  }, {
    key: "support",
    value: function support(direction) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.boundary(direction);
    }
  }, {
    key: "contains",
    value: function contains(point) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return new optim_1.Vector().subVectors(point, this.center).length() < this.radius.x;
    }
  }, {
    key: "constrainShapesWithin",
    value: function constrainShapesWithin(subshapes) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref7$masses = _ref7.masses,
          masses = _ref7$masses === void 0 ? {
        shape: 1,
        subshapes: 1
      } : _ref7$masses;

      // TODO: do something smarter than bounding rectangle enclosure
      var box = new three_1.Box2();
      subshapes.forEach(function (subshape) {
        var _subshape$bounds2 = subshape.bounds(),
            x = _subshape$bounds2.x,
            y = _subshape$bounds2.y,
            X = _subshape$bounds2.X,
            Y = _subshape$bounds2.Y;

        box.union(new three_1.Box2(new optim_1.Vector(x, y), new optim_1.Vector(X, Y)));
      });
      box.expandByScalar(offset);
      var centerGrad = new optim_1.Vector().subVectors(box.getCenter(new optim_1.Vector()), this.center).multiplyScalar(masses.subshapes / (masses.shape + masses.subshapes));
      var controlGrad = new optim_1.Vector().subVectors(new optim_1.Vector(box.getSize(new optim_1.Vector()).multiplyScalar(0.5).length(), 0), this.radius);
      var subshapeGrad = new optim_1.Vector().subVectors(box.getCenter(new optim_1.Vector()), this.center).multiplyScalar(-masses.shape / (masses.shape + masses.subshapes));
      return [new optim_1.Gradient(this.center, centerGrad), new optim_1.Gradient(this.radius, controlGrad)].concat(_toConsumableArray(subshapes.map(function (s) {
        return new optim_1.Gradient(s.center, subshapeGrad.clone());
      })));
    }
  }, {
    key: "constrainPointWithin",
    value: function constrainPointWithin(point) {
      var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref8$masses = _ref8.masses,
          masses = _ref8$masses === void 0 ? {
        shape: 1,
        point: 1
      } : _ref8$masses,
          _ref8$expansion = _ref8.expansion,
          expansion = _ref8$expansion === void 0 ? 0 : _ref8$expansion,
          _ref8$offset = _ref8.offset,
          offset = _ref8$offset === void 0 ? 0 : _ref8$offset;

      if (this.contains(point, offset)) return [];
      return this.constrainPointOnBoundary(point, {
        masses: masses,
        expansion: expansion,
        offset: offset
      });
    }
  }, {
    key: "constrainPointOnBoundary",
    value: function constrainPointOnBoundary(point) {
      var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref9$masses = _ref9.masses,
          masses = _ref9$masses === void 0 ? {
        shape: 1,
        point: 1
      } : _ref9$masses,
          _ref9$expansion = _ref9.expansion,
          expansion = _ref9$expansion === void 0 ? 0 : _ref9$expansion,
          _ref9$offset = _ref9.offset,
          offset = _ref9$offset === void 0 ? 0 : _ref9$offset;

      var centerToPoint = new optim_1.Vector().subVectors(point, this.center);
      var boundary = this.boundary(centerToPoint, offset).sub(this.center);
      var boundaryToPointOffset = centerToPoint.length() - boundary.length();
      var pointDelta = -boundaryToPointOffset * (masses.shape / (masses.shape + masses.point));
      var shapeDelta = boundaryToPointOffset * (masses.point / (masses.shape + masses.point));
      var centerDelta = shapeDelta * (1 - expansion);
      var boundaryDelta = shapeDelta * expansion;
      centerToPoint.normalize();
      var pointGrad = new optim_1.Gradient(point, centerToPoint.clone().multiplyScalar(pointDelta));
      var centerGrad = new optim_1.Gradient(this.center, centerToPoint.clone().multiplyScalar(centerDelta)); // TODO: Preserve ratio, size, none

      var controlGrad = new optim_1.Gradient(this.radius, this.radius.clone().multiplyScalar(boundaryDelta / boundary.length()));
      return [pointGrad, centerGrad, controlGrad];
    }
  }, {
    key: "toCollidable",
    value: function toCollidable() {
      return new sat_1.Circle(new sat_1.Vector(this.center.x, this.center.y), this.radius.x);
    }
  }, {
    key: "toSchema",
    value: function toSchema() {
      var preserve = this.preserve;
      return {
        type: 'circle',
        preserve: preserve,
        radius: this.radius.x
      };
    }
  }]);

  return Circle;
}(Shape);

exports.Circle = Circle;
/**
 * Returns the point on a line segment intersected by a ray coming from the origin, or undefined if
 * no intersection. Segment and ray must not be degenerate (with zero length).
 * @param start
 *    Start point of segment with respect to the orgin.
 * @param end
 *    End point of segment with respect to the origin.
 * @param ray
 *    Direction vector of ray starting from the orgin.
 */

function intersectSegment(start, end, ray) {
  // Formulas for t and s derived by solving a system of linear equations:
  // [x, y] = start * (1 - t) + end * t,   where t in [0, 1]
  // [x, y] = ray * s,   where s in [0, inf)
  var delta = new optim_1.Vector().subVectors(end, start);
  var denom = ray.y * delta.x - ray.x * delta.y;
  if (Math.abs(denom) < 1e-6) return undefined; // Ray and segment are parallel.

  var t = (ray.x * start.y - ray.y * start.x) / denom;
  var s = (delta.x * start.y - delta.y * start.x) / denom;
  if (t < 0 || 1 < t || s < 0) return undefined; // Ray doesn't point towards segment.

  return start.clone().multiplyScalar(1 - t).addScaledVector(end, t);
}